import { combineReducers } from 'redux';

import { reportUnloadingReducer } from './ReportUnloading/reducer';
import { reportLoadingReducer } from './ReportLoading/reducer';
import { report2359Reducer } from './Report2359/reducer';
import { BlackListReducer } from './ReportSpecialList/reducer';

export const reportsReducer = combineReducers({
  reportUnloadingReducer,
  reportLoadingReducer,
  report2359Reducer,
  BlackListReducer,
});

export type SecurityReportsState = ReturnType<typeof reportsReducer>;
